// ============================================
// Leka — Auth Store (Zustand 5, no persist)
// ============================================
import { create } from 'zustand'

export interface AuthUser {
  id: string
  email: string
  name: string
  image?: string
}

interface AuthState {
  user: AuthUser | null
  isLoading: boolean
  error: string | null
  setUser: (user: AuthUser | null) => void
  setLoading: (loading: boolean) => void
  setError: (error: string | null) => void
  reset: () => void
}

export const useAuthStore = create<AuthState>()((set) => ({
  user: null,
  isLoading: true,
  error: null,

  setUser: (user) => set({ user, isLoading: false, error: null }),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error, isLoading: false }),
  reset: () => set({ user: null, isLoading: false, error: null }),
}))
